import { createAsyncThunk } from "@reduxjs/toolkit";
import { MiscActions } from "./MiscSlice";
import { BrandColorType, MiscStateType, RootState } from "src/shared/types/src";
import { getBrandingBorderColor, getForegroundColor } from "src/shared/utils/src";

export const updateHardRefresh = createAsyncThunk(
    "updateHardRefresh", async (payload: { refresh: boolean }, { dispatch }) => {
        dispatch(MiscActions.setHardRefresh({ hardRefresh: payload.refresh }));
    }
);

export const updateRefreshLastObservation = createAsyncThunk(
    "updateRefreshLastObservation", async (payload: { refresh: boolean }, { dispatch }) => {
        dispatch(MiscActions.setLastObservationRefresh({ refresh: payload.refresh }));
    }
);

export const updatShowDownloadAppBanner = createAsyncThunk(
    "updatShowDownloadAppBanner", async (payload: { showDownloadAppBanner: boolean }, { dispatch }) => {
        dispatch(MiscActions.setShowDownloadAppBanner({ showDownloadAppBanner: payload.showDownloadAppBanner }));
    }
);

// export const getHardRefresh = (state: RootState) => state.misc.hardRefreshApp ?? false;

export const calculateThemeColors = createAsyncThunk(
    "calculateThemeColors", async (payload: { brandColor: string }, { dispatch }) => {
        const backgroundColor: string = payload.brandColor;
        const foregroundColor: string = getForegroundColor(payload.brandColor);

        const darkModeBorderConfig = getBrandingBorderColor(payload.brandColor, true);
        const lightModeBorderConfig = getBrandingBorderColor(payload.brandColor, false);

        const darkModeConfig: BrandColorType = {
            backgroundColor,
            foregroundColor,
            borderColor: darkModeBorderConfig?.borderColor,
            showBrandBorder: darkModeBorderConfig?.showBorder
        }

        const lightModeConfig: BrandColorType = {
            backgroundColor,
            foregroundColor,
            borderColor: lightModeBorderConfig?.borderColor,
            showBrandBorder: lightModeBorderConfig?.showBorder
        }

        await dispatch(MiscActions.setThemeColors({
            dark: darkModeConfig,
            light: lightModeConfig
        } as MiscStateType['themeColors']))
    }
);



